import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import WindowBrowser from "../components/browser-window";
import Scrollspy from 'react-scrollspy';

const Attribution = () => {
  useEffect(() => {
    // Listen to size change and update form height
    const handleResizeMessage = (e) => {
      if (e.origin === "https://teams.igem.org") {
        const { type, data } = JSON.parse(e.data);
        if (type === "igem-attribution-form") {
          const element = document.getElementById("igem-attribution-form");
          element.style.height = `${data + 100}px`;
        }
      }
    };

    window.addEventListener("message", handleResizeMessage);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("message", handleResizeMessage);
    };
  }, []);

  return (
    <div className="row mt-4" style={{ overflow: "hidden", padding: 0, margin: 0 }}>
      {/* Container for WindowBrowser with padding */}
      <div style={{ padding: "40px" }}> {/* Adds padding around the entire WindowBrowser */}
        <WindowBrowser description={
          <div>
            <iframe
              style={{ width: "100%", height: "80vh", border: "none" }} // Set height to a percentage of the viewport height
              id="igem-attribution-form"
              src="https://teams.igem.org/wiki/5334/attributions"
              title="IGEM Attribution Form"
            />
          </div>
        }></WindowBrowser>
      </div>
    </div>
  );
};

export default Attribution;
